module.exports = __webpack_public_path__ + "static/media/fan_feedback.0c3b57f3.png";